.fp-vertical-spacing(v-if='recommendedExclusives.length' data-test='recommended-exclusives')
  .fp-vertical-spacing--line
    h2.fp-title {{ t('marketplace.recommendedExclusives') }}
  .fp-vertical-spacing--line
    ExclusivesCarouselVue(:exclusives='recommendedExclusives' :show-like='showLike')
